// extracted by mini-css-extract-plugin
export var modalFooter = "_ry-0";